@if (tecnicos) {
  <mat-card class="asignar-tecnico-card">
    <app-card-header
      title="Asignar Técnico"
      subtitle="Técnico a asignar y fecha disponible para tratar el servicio"
      icono="engineering"
      [botonCerrar]="true"
      (cerrar)="cerrarDialog()"
    ></app-card-header>

    <mat-card-content class="card-content-crear">
      <!-- Técnico -->
      <app-content-card title="Técnico Asignado" icon="engineering">
        <div class="form-section">
          <mat-checkbox
            [(ngModel)]="verTodos"
            (ngModelChange)="cambiarVerTodos()"
            style="margin-bottom: 8px"
          >
            Ver todos los técnicos (no solo los del cliente)
          </mat-checkbox>
          <div class="tecnico-selector-row">
            <ng-select
              [items]="tecnicos"
              bindValue="_id"
              bindLabel="label"
              [ngModel]="idTecnicoSeleccionado"
              placeholder="Seleccionar Técnico"
              [notFoundText]="'No hay técnicos creados'"
              [multiple]="false"
              [searchable]="true"
              appendTo="body"
              style="flex: 1"
              (change)="onChange($event)"
              (clear)="onClear()"
            >
              <!-- Tag (estilos inline: el panel/valor vive fuera del componente) -->
              <ng-template ng-label-tmp let-item="item">
                <div style="display: flex; align-items: center; gap: 8px">
                  @if (item.datosPersonales?.foto) {
                    <div
                      style="
                        width: 24px;
                        height: 24px;
                        border-radius: 50%;
                        background-size: cover;
                        background-position: center;
                        flex-shrink: 0;
                      "
                      [style.background-image]="
                        'url(' + item.datosPersonales.foto + ')'
                      "
                    ></div>
                  }
                  <span>
                    {{ item.datosPersonales?.nombre || item?.usuario }}
                  </span>
                </div>
              </ng-template>
              <!-- Opción -->
              <ng-template ng-option-tmp let-item="item">
                <div
                  style="
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    padding: 4px 0;
                  "
                >
                  @if (item.datosPersonales?.foto) {
                    <div
                      style="
                        width: 32px;
                        height: 32px;
                        border-radius: 50%;
                        background-size: cover;
                        background-position: center;
                        flex-shrink: 0;
                      "
                      [style.background-image]="
                        'url(' + item.datosPersonales.foto + ')'
                      "
                    ></div>
                  }
                  <span style="font-size: 14px">
                    {{ item.datosPersonales?.nombre || item?.usuario }}
                  </span>
                </div>
              </ng-template>
            </ng-select>

            <app-button
              matType="mat-fab"
              color="primary"
              icon="add"
              [tooltip]="'Crear nuevo técnico'"
              (click)="crear()"
            ></app-button>
          </div>
        </div>
      </app-content-card>

      <!-- Vehículo del técnico (queda como conductor) -->
      @if (moduloVehiculos && idTecnicoSeleccionado) {
        <app-content-card title="Vehículo" icon="directions_car">
          <div class="form-section vehiculo-section">
            @if (puedeAsignarVehiculo) {
              <mat-checkbox
                [(ngModel)]="verTodosVehiculos"
                (ngModelChange)="cargarVehiculos()"
              >
                Ver todos los vehículos de servicio técnico (no solo los del
                cliente)
              </mat-checkbox>
            }
            @if (cargandoVehiculos) {
              <div class="row-center">
                <mat-progress-spinner
                  mode="indeterminate"
                  diameter="20"
                ></mat-progress-spinner>
              </div>
            } @else {
              <div class="vehiculo-actual">
                <mat-icon>directions_car</mat-icon>
                @if (vehiculoActual) {
                  <span>
                    Conductor de
                    <strong>{{ labelVehiculoActual() }}</strong>
                  </span>
                } @else {
                  <span class="sin-vehiculo">Sin vehículo asignado</span>
                }
              </div>

              @if (puedeAsignarVehiculo) {
                <ng-select
                  [items]="vehiculos"
                  bindValue="_id"
                  bindLabel="label"
                  [(ngModel)]="idVehiculoSeleccionado"
                  placeholder="Asignar vehículo (opcional)"
                  [notFoundText]="
                    'No hay vehículos con función Servicio Técnico'
                  "
                  [searchable]="true"
                  appendTo="body"
                >
                  <!-- Opción (estilos inline: el panel vive fuera del componente) -->
                  <ng-template ng-option-tmp let-item="item">
                    <div style="display: flex; flex-direction: column">
                      <span>{{ item.label }}</span>
                      @if (verTodosVehiculos && item.cliente?.nombre) {
                        <small style="opacity: 0.7">
                          Cliente: {{ item.cliente.nombre }}
                        </small>
                      }
                      @if (
                        item.vehiculo?.chofer &&
                        item.vehiculo?.idChofer !== idTecnicoSeleccionado
                      ) {
                        <small style="opacity: 0.7">
                          Conductor: {{ nombreUsuario(item.vehiculo.chofer) }}
                        </small>
                      }
                    </div>
                  </ng-template>
                </ng-select>

                @for (aviso of avisosVehiculo(); track aviso) {
                  <div class="aviso-vehiculo">
                    <mat-icon>info</mat-icon>
                    <span>{{ aviso }}</span>
                  </div>
                }
              }
            }
          </div>
        </app-content-card>
      }

      <!-- Materiales asignados al técnico (su caja) -->
      @if (idTecnicoSeleccionado) {
        <app-content-card title="Materiales" icon="inventory_2">
          <div class="form-section materiales-section">
            @if (cargandoMateriales) {
              <div class="row-center">
                <mat-progress-spinner
                  mode="indeterminate"
                  diameter="20"
                ></mat-progress-spinner>
              </div>
            } @else if (materialesTecnico.length) {
              <div class="materiales-tecnico-lista">
                @for (m of materialesTecnico; track m.nombre) {
                  <div class="material-item">
                    <span>{{ m.nombre }}</span>
                    <b>×{{ m.cantidad }}</b>
                  </div>
                }
              </div>
            } @else {
              <p class="materiales-tecnico-vacio">
                Este técnico no tiene materiales asignados.
              </p>
            }

            @if (puedeAsignarMateriales && tecnico) {
              <div>
                <button
                  irxBoton="secundario"
                  type="button"
                  (click)="abrirAsignarMateriales()"
                >
                  <mat-icon>inventory_2</mat-icon>
                  Asignar materiales a este técnico
                </button>
              </div>
            }
          </div>
        </app-content-card>
      }

      <!-- Disponibilidad -->
      <app-content-card title="Disponibilidad" icon="date_range">
        <div class="form-section">
          <mat-form-field style="width: 100%">
            <mat-label>Fecha disponible para tratar</mat-label>
            <input
              matInput
              [matDatepicker]="picker"
              [(ngModel)]="fechaDisponibleParaTratar"
              placeholder="DD/MM/YYYY"
            />
            <button
              irxBotonIcono
              tamano="compacto"
              matSuffix
              tooltip="Elegir fecha"
              (click)="picker.open()"
            >
              <mat-icon>calendar_month</mat-icon>
            </button>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
        </div>
      </app-content-card>
    </mat-card-content>

    <mat-card-actions class="actions-create">
      <button irxBoton="secundario" type="button" (click)="cerrarDialog()">
        Cancelar
      </button>
      <span class="pie-espacio"></span>
      @if (idTecnicoSeleccionado) {
        <button
          irxBoton="peligro-borde"
          type="button"
          [disabled]="loading()"
          (click)="desasignar()"
        >
          <mat-icon>person_remove</mat-icon>
          Desasignar
        </button>
      }
      <button
        irxBoton="principal"
        type="button"
        [disabled]="loading()"
        (click)="asignar()"
      >
        <mat-icon>engineering</mat-icon>
        Asignar
      </button>
    </mat-card-actions>
  </mat-card>
} @else {
  <div class="row-center">
    <mat-progress-spinner
      mode="indeterminate"
      diameter="20"
    ></mat-progress-spinner>
  </div>
}
